"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _intl = require("../intl");

/** This component set intl util injected by injectIntl as exportable  */
var IntlSetter = function IntlSetter(_ref) {
  var children = _ref.children,
      intl = _ref.intl;
  (0, _intl.setIntl)(intl);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children);
};

IntlSetter.propTypes = {
  children: _propTypes.default.node,
  intl: _propTypes.default.object
};
IntlSetter.displayName = 'IntlSetter';

var _default = (0, _reactIntl.injectIntl)(IntlSetter);

exports.default = _default;